import {
  addDays,
  endOfMonth,
  endOfWeek,
  endOfYear,
  format,
  startOfMonth,
  startOfWeek,
  startOfYear,
  startOfYesterday,
  subDays,
  subMonths,
  subWeeks,
  subYears
} from 'date-fns';
import Rpipe from 'ramda/es/pipe';

import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

export type StrOrDate = string | Date;

export function formatDate(date: StrOrDate = new Date(), form = 'YYYY-MM-DD'): string {
  return format(legacyParse(date), convertTokens(form));
}

export function getPreviousDay(): string {
  return Rpipe(startOfYesterday, formatDate)();
}

export function getStartOfWeek(date: StrOrDate = new Date()): string {
  return formatDate(startOfWeek(legacyParse(date), { weekStartsOn: 1 }));
}

export function getEndOfWeek(date: StrOrDate = new Date()): string {
  return formatDate(endOfWeek(legacyParse(date), { weekStartsOn: 1 }));
}

export function getEndOf2Week(date: StrOrDate = new Date()): string {
  const newDate = addDays(legacyParse(endOfWeek(legacyParse(date), { weekStartsOn: 1 })), 7);
  return formatDate(newDate);
}

export function getEndOf4Week(date: StrOrDate = new Date()): string {
  const newDate = addDays(legacyParse(endOfWeek(legacyParse(date), { weekStartsOn: 1 })), 21);
  return formatDate(newDate);
}

export function getStartOfPreviousWeek(): string {
  const pipe = Rpipe(getStartOfWeek, formatDate);

  return pipe(subWeeks(legacyParse(new Date()), 1));
}

export function getEndOfPreviousWeek(): string {
  const pipe = Rpipe(getEndOfWeek, formatDate);
  return pipe(subWeeks(legacyParse(new Date()), 1));
}

export function getStartOfMonth(date: StrOrDate = new Date()): string {
  return Rpipe(startOfMonth, formatDate)(date);
}

export function getEndOfMonth(date: StrOrDate = new Date()): string {
  return Rpipe(endOfMonth, formatDate)(date);
}

export function getStartOfPreviousMonth(date: StrOrDate = new Date()): string {
  return getStartOfMonth(subMonths(legacyParse(date), 1));
}

export function getEndOfPreviousMonth(date: StrOrDate = new Date()): string {
  return getEndOfMonth(subMonths(legacyParse(date), 1));
}

export function getStartOfYear(date: StrOrDate = new Date()): string {
  return formatDate(startOfYear(legacyParse(date)));
}

export function getEndOfYear(date: StrOrDate = new Date()): string {
  return formatDate(endOfYear(legacyParse(date)));
}

export function getStartOfPreviousYear(date: StrOrDate = new Date()): string {
  return getStartOfYear(subYears(legacyParse(date), 1));
}

export function getEndOfPreviousYear(date: StrOrDate = new Date()): string {
  return getEndOfYear(subYears(legacyParse(date), 1));
}

export function subDaysFromCurrentDate(date: StrOrDate = new Date(), daysAmount: number): string {
  return formatDate(subDays(legacyParse(date), daysAmount));
}

export function subMonthsFromCurrentDate(date: StrOrDate = new Date(), monthsAmount: number): string {
  return formatDate(subMonths(legacyParse(date), monthsAmount));
}
